<template>
  <transition :name="transitionName" @after-leave="$emit('dodestroy')">
    <div
      v-show="visible"
      id="kye-date3-range"
      class="el-picker-panel el-date-range-picker el-popper"
      :class="[
        {
          'has-sidebar': $slots.sidebar || shortcuts,
          'has-time': showTime
        },
        popperClass
      ]">
      <div
        class="el-picker-panel__body-wrapper"
        :class="{ 'hidden-border-left': !showShortcuts || !shortcuts || !shortcuts.length }">
        <slot name="sidebar" class="el-picker-panel__sidebar"></slot>
        <!-- <div class="el-picker-panel__sidebar" v-if="showShortcuts && shortcuts && shortcuts.length">
          <button
            type="button"
            class="el-picker-panel__shortcut kye-date3-shortcut"
            v-for="(shortcut, key) in showMonthSelect ? monthShortcuts : shortcuts"
            :key="key"
            :class="{
              'is-disabled': typeof shortcut.disabled === 'function' ? shortcut.disabled() : !!shortcut.disabled
            }"
            @click="handleShortcutClick(shortcut)">
            {{ shortcut.text }}
          </button>
        </div> -->
        <ShortcutsWrap
          v-if="showShortcuts"
          :type="type"
          :date="rangeDate"
          :shortcuts="shortcuts"
          :disabledDate="disabledDate"
          :clearable="clearable"
          :showMonthSelect="showMonthSelect"
          :changeShortcutMonth="changeShortcutMonth"
          :handleShortcutMonthClick="handleShortcutMonthClick"
          :handleShortcutClick="handleShortcutClick"
        >
        </ShortcutsWrap>
        <div class="el-picker-panel__body">
          <!-- 头部slot -->
          <component :is="headerSlotRender" />
          <div class="el-date-range-picker__time-header" v-if="showTime">
            <span class="el-date-range-picker__editors-wrap" v-if="showStartInputTimer">
              <span class="el-date-range-picker__time-picker-wrap">
                <el-input
                  style="width: 135px"
                  size="small"
                  :disabled="rangeState.selecting"
                  ref="minInput"
                  :placeholder="t('el.datepicker.startDate')"
                  class="el-date-range-picker__editor"
                  :value="minVisibleDate"
                  @input.native="handleDateInput($event, 'min')"
                  @change.native="handleDateChange($event, 'min')" />
              </span>
              <span class="el-date-range-picker__time-picker-wrap" v-clickoutside="handleMinTimeClose">
                <el-input
                  style="width: 135px"
                  size="small"
                  :disabled="rangeState.selecting"
                  :placeholder="t('el.datepicker.startTime')"
                  class="el-date-range-picker__editor"
                  :value="minVisibleTime"
                  @focus="minTimePickerVisible = true"
                  @change.native="handleTimeChange($event, 'min')" />
                <time-picker
                  ref="minTimePicker"
                  @pick="handleMinTimePick"
                  :time-arrow-control="arrowControl"
                  :visible="minTimePickerVisible"
                  @mounted="$refs.minTimePicker.format = timeFormat">
                </time-picker>
              </span>
            </span>
            <!-- <span class="el-icon-arrow-right"></span> -->
            <span class="el-date-range-picker__editors-wrap" v-if="showEndInputTimer">
              <span class="el-date-range-picker__time-picker-wrap">
                <el-input
                  size="small"
                  style="width: 135px"
                  :disabled="rangeState.selecting"
                  :placeholder="t('el.datepicker.endDate')"
                  class="el-date-range-picker__editor"
                  :value="maxVisibleDate"
                  :readonly="!minDate"
                  @input.native="handleDateInput($event, 'max')"
                  @change.native="handleDateChange($event, 'max')" />
              </span>
              <span class="el-date-range-picker__time-picker-wrap" v-clickoutside="handleMaxTimeClose">
                <el-input
                  size="small"
                  style="width: 135px"
                  :disabled="rangeState.selecting"
                  ref="maxInput"
                  :placeholder="t('el.datepicker.endTime')"
                  class="el-date-range-picker__editor"
                  :value="maxVisibleTime"
                  @focus="minDate && (maxTimePickerVisible = true)"
                  :readonly="!minDate"
                  @change.native="handleTimeChange($event, 'max')" />
                <time-picker
                  ref="maxTimePicker"
                  @pick="handleMaxTimePick"
                  :time-arrow-control="arrowControl"
                  :visible="maxTimePickerVisible"
                  @mounted="$refs.maxTimePicker.format = timeFormat">
                </time-picker>
              </span>
            </span>
          </div>
          <div class="el-picker-panel__content el-date-range-picker__content is-left">
            <div class="el-date-range-picker__header">
              <div class="el-date-range-picker__header_left">
                <button
                  type="button"
                  @click="leftPrevYear"
                  class="el-picker-panel__icon-btn el-icon-d-arrow-left"></button>
                <button
                  type="button"
                  @click="leftPrevMonth"
                  class="el-picker-panel__icon-btn el-icon-arrow-left"></button>
              </div>
              <!-- <div>{{ activeInputIndex === 0 ? leftLabel : rightLabel }}</div> -->
              <div class="label">
                <span>{{ rangeLabel[0] }}</span>
                <span>{{ rangeLabel[1] }}</span>
              </div>
              <div class="el-date-range-picker__header_right">
                <button
                  type="button"
                  @click="rightNextYear"
                  class="el-picker-panel__icon-btn el-icon-d-arrow-right"></button>
                <button
                  type="button"
                  @click="rightNextMonth"
                  class="el-picker-panel__icon-btn el-icon-arrow-right"></button>
              </div>
            </div>
            <date-table
              :showLunar="showLunar"
              :requireBoth="requireBoth"
              :singleValue="singleValue"
              :isWeekRange="isWeekRange"
              ref="leftDateTable"
              :showWeekNumber="showWeekNumber"
              :selection-mode="isWeekRange ? 'week' : 'range'"
              :date="rangeDate"
              :default-value="defaultValue"
              :min-date="minDate"
              :max-date="maxDate"
              :activeInputIndex="activeInputIndex"
              :range-state="isWeekRange ? undefined : rangeState"
              :cellPopperContent="cellPopperContent"
              :disabled-date="disabledDate"
              :cell-class-name="cellClassName"
              @changerange="handleChangeRange"
              :first-day-of-week="firstDayOfWeek"
              @pick="handleRangePick">
            </date-table>
          </div>
          <div class="el-picker-panel__content el-date-range-picker__content is-right"></div>
        </div>
      </div>
      <div class="el-picker-panel__footer" v-if="showTime">
        <!-- <el-button v-if="showClear" type="text" size="mini" @click="handleClear">
          {{ t('el.datepicker.clear') }}
        </el-button> -->
        <el-button v-if="showReset" size="mini"  @click="handleReset">重置</el-button>
        <el-button v-if="showConfirm" size="mini" type="primary" :disabled="btnDisabled" @click="handleConfirm(false)">
          {{ t('el.datepicker.confirm') }}
        </el-button>
      </div>
    </div>
  </transition>
</template>

<script type="text/babel">
import moment from 'moment'
// import { isObject } from 'lodash'
import {
  formatDate,
  parseDate,
  isDate,
  modifyDate,
  modifyTime,
  modifyWithTimeString,
  prevYear,
  nextYear,
  prevMonth,
  nextMonth,
  extractDateFormat,
  extractTimeFormat,
  correctDatesOrder,
  // VALUE_FORMAT,
  FORMAT
} from '../util'
import Clickoutside from 'element-ui/lib/utils/clickoutside'
import Locale from 'element-ui/lib/mixins/locale'
import TimePicker from './time'
import DateTable from '../basic/date-table'
import ShortcutsWrap from '../basic/shortcuts-wrap'
import '../style/date-range.scss'

const advanceDate = (date, amount) => {
  return new Date(new Date(date).getTime() + amount)
}

const calcDefaultValue = defaultValue => {
  if (Array.isArray(defaultValue)) {
    return [new Date(defaultValue[0]), new Date(defaultValue[1])]
  } else if (defaultValue) {
    return [new Date(defaultValue), advanceDate(defaultValue, 24 * 60 * 60 * 1000)]
  } else {
    return [new Date(), advanceDate(Date.now(), 24 * 60 * 60 * 1000)]
  }
}

export default {
  mixins: [Locale],

  directives: { Clickoutside },

  computed: {
    showStartInputTimer() {
      // 单边时，需要展示单边的输入框数据
      return this.activeInputIndex === 0
    },
    showEndInputTimer() {
      // 单边时，需要展示单边的输入框数据
      return this.activeInputIndex === 1
    },
    btnDisabled() {
      return !(this.minDate && this.maxDate && !this.selecting && this.isValidValue([this.minDate, this.maxDate]))
    },

    // rangeDate() {
    //   return this.activeInputIndex === 0 ? this.leftDate : this.rightDate
    // },

    rangeLabel() {
      return [this.rangeDate.getFullYear() + this.t('el.datepicker.year'), this.rangeDate.getMonth() + 1 + '月']
    },

    leftLabel() {
      return [this.leftDate.getFullYear() + this.t('el.datepicker.year'), this.leftDate.getMonth() + 1 + '月']
    },

    rightLabel() {
      return [this.rightDate.getFullYear() + this.t('el.datepicker.year'), this.rightDate.getMonth() + 1 + '月']
    },

    leftYear() {
      return this.leftDate.getFullYear()
    },

    leftMonth() {
      return this.leftDate.getMonth()
    },

    leftMonthDate() {
      return this.leftDate.getDate()
    },

    rightYear() {
      return this.rightDate.getFullYear()
    },

    rightMonth() {
      return this.rightDate.getMonth()
    },

    rightMonthDate() {
      return this.rightDate.getDate()
    },

    minVisibleDate() {
      return this.minDate ? formatDate(this.minDate, this.dateFormat) : ''
    },

    maxVisibleDate() {
      return this.maxDate || this.minDate ? formatDate(this.maxDate || this.minDate, this.dateFormat) : ''
    },

    minVisibleTime() {
      return this.minDate ? formatDate(this.minDate, this.timeFormat) : ''
    },

    maxVisibleTime() {
      return this.maxDate || this.minDate ? formatDate(this.maxDate || this.minDate, this.timeFormat) : ''
    },

    timeFormat() {
      if (this.format) {
        return extractTimeFormat(this.format)
      } else {
        return 'HH:mm:ss'
      }
    },

    dateFormat() {
      if (this.format) {
        return extractDateFormat(this.format)
      } else {
        return 'yyyy-MM-dd'
      }
    },

    headerSlotRender() {
      if (typeof this.headerSlot === 'function') {
        return {
          render: this.headerSlot
        }
      }
      return {
        render: h => (Array.isArray(this.headerSlot) ? this.headerSlot[0] : null || null)
      }
    }
  },

  data() {
    return {
      popperClass: '',
      value: [],
      defaultValue: null,
      defaultTime: null,
      minDate: '',
      maxDate: '',
      rangeDate: new Date(),
      leftDate: new Date(),
      rightDate: nextMonth(new Date()),
      rangeState: {
        endDate: null,
        selecting: false,
        row: null,
        column: null
      },
      showTime: false,
      shortcuts: '',
      visible: '',
      disabledDate: '',
      firstDayOfWeek: 7,
      minTimePickerVisible: false,
      maxTimePickerVisible: false,
      format: '',
      arrowControl: false,
      cellPopperContent: null,
      leftCellPopperContent: null,
      rightCellPopperContent: null,
      inputTimeType: 'min',
      isWeekRange: false,
      showWeekNumber: false,
      activeInputIndex: 0,
      showLunar: true,
      requireBoth: true,
      type: 'daterange',
      clearable: true,
      beforeShortcutsClick: null,
      shortcutsCallback: null,
      monthShortcutsCallback: null,
      showMonthSelect: false,
      singleValue: false,
      cellClassName: '',
      showShortcuts: true,
      headerSlot: null,
      transitionName: 'el-zoom-in-top',
      showClear: true,
      showReset: true,
      showConfirm: true,
      linkPanels: false
    }
  },

  watch: {
    minDate(val) {
      this.$nextTick(() => {
        if (this.$refs.maxTimePicker && this.maxDate && this.maxDate < this.minDate) {
          const format = 'HH:mm:ss'
          this.$refs.maxTimePicker.selectableRange = [
            [parseDate(formatDate(this.minDate, format), format), parseDate('23:59:59', format)]
          ]
        }
      })
      if (val && this.$refs.minTimePicker) {
        this.$refs.minTimePicker.date = val
        this.$refs.minTimePicker.value = val
      }
    },

    maxDate(val) {
      if (val && this.$refs.maxTimePicker) {
        this.$refs.maxTimePicker.date = val
        this.$refs.maxTimePicker.value = val
      }
    },

    minTimePickerVisible(val) {
      if (val) {
        this.$nextTick(() => {
          this.$refs.minTimePicker.date = this.minDate
          this.$refs.minTimePicker.value = this.minDate
          this.$refs.minTimePicker.adjustSpinners()
        })
      }
    },

    maxTimePickerVisible(val) {
      if (val) {
        this.$nextTick(() => {
          this.$refs.maxTimePicker.date = this.maxDate
          this.$refs.maxTimePicker.value = this.maxDate
          this.$refs.maxTimePicker.adjustSpinners()
        })
      }
    },

    value(newVal) {
      if (!newVal) {
        this.minDate = null
        this.maxDate = null
      } else if (Array.isArray(newVal)) {
        this.minDate = isDate(newVal[0]) ? new Date(newVal[0]) : null
        this.maxDate = isDate(newVal[1]) ? new Date(newVal[1]) : null
        // 单边时，处理此时左右面板激活的数据
        if (this.singleValue) {
          // // 开始时间
          // if (this.minDate) {
          //   // 如果当前选择的与上一次相比 ,都在同一个面板上，则使用之前的，防止跳动
          //   const inRange = this.dateIsRangeInDateTableRows(this.minDate)
          //   if (inRange) {
          //     return
          //   }
          //   // 如果不在面板数据内。且最大值又在面板内，则表示。现在的最小值变为了最大值，则判断。最大值是否在当前面板中，且也不能切换面板。
          //   if (this.maxDate) {
          //     // 如果当前选择的与上一次相比 ,都在同一个面板上，则使用之前的，防止跳动
          //     const inRange = this.dateIsRangeInDateTableRows(this.maxDate)
          //     if (inRange) {
          //       return
          //     }
          //   }
          //   // 以上都不成立，展示当前的值或者 默认值。
          //   this.leftDate = this.minDate || calcDefaultValue(this.defaultValue)[0]
          // }
          // // 结束时间
          // if (this.maxDate) {
          //   // 如果当前选择的与上一次相比 ,都在同一个面板上，则使用之前的，防止跳动
          //   const inRange = this.dateIsRangeInDateTableRows(this.maxDate)
          //   if (inRange) {
          //     return
          //   }
          //   this.rightDate = this.maxDate
          // } else {
          //   // 不存在，使用下一个月数据
          //   // this.rightDate = nextMonth(this.leftDate)
          //   this.rangeDate = this.maxDate
          // }
          if ([this.minDate, this.maxDate].some(Boolean)) {
            return
          }

          if (!this.minDate && !this.maxDate) {
            this.rangeDate = calcDefaultValue(this.defaultValue)[0]
          }
          return
        }

        // 都有值或者无值
        if (this.minDate) {
          // this.leftDate = this.minDate
          // this.rightDate = nextMonth(this.leftDate)
          this.rangeDate = this.activeInputIndex === 0 ? this.minDate : this.maxDate
        } else {
          // this.leftDate = calcDefaultValue(this.defaultValue)[0]
          // this.rightDate = nextMonth(this.leftDate)
          this.rangeDate = calcDefaultValue(this.defaultValue)[0]
        }
      }
    },

    defaultValue(val) {
      if (!Array.isArray(this.value)) {
        const [left] = calcDefaultValue(val)
        // this.leftDate = left
        // this.rightDate = nextMonth(this.leftDate)
        this.rangeDate = left
      }
    },

    activeInputIndex(val) {
      // const value = this.value || []
      // const minDate = isDate(value[0]) ? new Date(value[0]) : null
      // const maxDate = isDate(value[1]) ? new Date(value[1]) : null
      // if (val === 0 && minDate) {
      //   this.rangeDate = minDate
      // }
      // if (val === 1 && maxDate) {
      //   this.rangeDate = maxDate
      // }
    },

    visible() {
      // this.isPanelSelectd = false
    }
  },

  methods: {
    handleFocus() {
      const value = this.value || []
      const minDate = isDate(value[0]) ? new Date(value[0]) : null
      const maxDate = isDate(value[1]) ? new Date(value[1]) : null
      const activeInputIndex = this.activeInputIndex
      if (activeInputIndex === 0 && minDate) {
        this.rangeDate = minDate
      }
      if (activeInputIndex === 1 && maxDate) {
        this.rangeDate = maxDate
      }
    },
    // dateIsRangeInDateTableRows(date) {
    //   if (this.$refs && this.$refs.leftDateTable && this.$refs.leftDateTable.startEndDateRows) {
    //     const [s, e] = this.$refs.leftDateTable.startEndDateRows()
    //     if (s && e) {
    //       const _s = moment(s)
    //       const _e = moment(e)
    //       const _date = moment(moment(date).format('YYYY-MM-DD'))
    //       if (_date.isSameOrAfter(_s) && _date.isSameOrBefore(_e)) {
    //         return true
    //       }
    //     }
    //   }
    // },
    // 清除的逻辑
    handleClearOperation() {
      // 单边时，不走原有的逻辑，走专属的面板逻辑
      if (this.singleValue) {
        this.$emit('single-value-short-pick', { type: 'delete', value: '', activeInputIndex: this.activeInputIndex })
        return
      }
      // 如果清除所有的值，则直接返回空
      this.$emit('pick', [], false)
      // 新增点击快捷面板点击回调
      // const beforeShortcutsClick = this.beforeShortcutsClick
      // if (typeof beforeShortcutsClick === 'function') {
      //   beforeShortcutsClick({ picker, type: 'clear', start: '', end: '' })
      // }
    },
    handleReset() {
      this.$emit('pick', [], true)
    },
    setStartAndEndStyle(picker, { start, end }) {
      if (picker.$children.length) {
        let table = picker.$children.find(com => com.$vnode.componentOptions.tag === 'date-table')
        let _start = FORMAT(start, 'yyyy-MM-dd')
        let _end = FORMAT(end, 'yyyy-MM-dd')
        table.$nextTick(_ => {
          table.$el.querySelectorAll('td').forEach(el => {
            let _row = el.parentNode.rowIndex - 1
            let _column = el.cellIndex
            let _date = FORMAT(table.getDateOfCell(_row, _column), 'yyyy-MM-dd')
            if (_date === _start) {
              el.classList.add('kye-start')
            } else if (_date === _end) {
              el.classList.add('kye-end')
            } else {
              el.classList.remove('kye-start', 'kye-end')
            }
          })
        })
      }
    },
    handleClear() {
      this.minDate = null
      this.maxDate = null
      // this.leftDate = calcDefaultValue(this.defaultValue)[0]
      // this.rightDate = nextMonth(this.leftDate)
      this.rangeDate = calcDefaultValue(this.defaultValue)[0]
      this.$emit('pick', null)
    },

    handleChangeRange(val) {
      this.minDate = val.minDate
      this.maxDate = val.maxDate
      this.rangeState = val.rangeState
    },

    handleDateInput(event, type) {
      const value = event.target.value
      if (value.length !== this.dateFormat.length) return
      const parsedValue = parseDate(value, this.dateFormat)

      if (parsedValue) {
        if (typeof this.disabledDate === 'function' && this.disabledDate(new Date(parsedValue))) {
          return
        }
        if (type === 'min') {
          this.minDate = new Date(parsedValue)
          // this.leftDate = new Date(parsedValue)
          // this.rightDate = nextMonth(this.leftDate)
          // this.rangeDate = new Date(parsedValue)
        } else {
          this.maxDate = new Date(parsedValue)
          // this.leftDate = prevMonth(parsedValue)
          // this.rightDate = new Date(parsedValue)
        }
        this.rangeDate = new Date(parsedValue)
      }
    },

    handleDateChange(event, type) {
      const value = event.target.value
      const parsedValue = parseDate(value, this.dateFormat)
      if (parsedValue) {
        if (type === 'min') {
          this.minDate = modifyDate(
            this.minDate,
            parsedValue.getFullYear(),
            parsedValue.getMonth(),
            parsedValue.getDate()
          )
          if (this.minDate > this.maxDate) {
            this.maxDate = this.minDate
          }
        } else {
          this.maxDate = modifyDate(
            this.maxDate,
            parsedValue.getFullYear(),
            parsedValue.getMonth(),
            parsedValue.getDate()
          )
          if (this.maxDate < this.minDate) {
            this.minDate = this.maxDate
          }
        }
      }
    },

    handleTimeChange(event, type) {
      const value = event.target.value
      const parsedValue = parseDate(value, this.timeFormat)
      if (parsedValue) {
        if (type === 'min') {
          this.minDate = modifyTime(
            this.minDate,
            parsedValue.getHours(),
            parsedValue.getMinutes(),
            parsedValue.getSeconds()
          )
          if (this.minDate > this.maxDate) {
            this.maxDate = this.minDate
          }
          this.$refs.minTimePicker.value = this.minDate
          this.minTimePickerVisible = false
        } else {
          this.maxDate = modifyTime(
            this.maxDate,
            parsedValue.getHours(),
            parsedValue.getMinutes(),
            parsedValue.getSeconds()
          )
          if (this.maxDate < this.minDate) {
            this.minDate = this.maxDate
          }
          this.$refs.maxTimePicker.value = this.minDate
          this.maxTimePickerVisible = false
        }
      }
    },
    handleWeekRangePick(val, close = true) {
      const { date } = val
      if (this.minDate && this.maxDate) {
        this.minDate = date
        this.maxDate = null
      } else if (!this.minDate) {
        this.minDate = date
      } else if (this.minDate && !this.maxDate) {
        this.maxDate = date
      }

      this.onPick && this.onPick(val)
      if (!close || this.showTime) return
      this.handleConfirm()
    },

    handleRangePick(val, close = true) {
      if (this.isWeekRange) {
        this.handleWeekRangePick(val, close)
        return
      }
      const defaultTime = this.defaultTime || []
      const minDate = modifyWithTimeString(val.minDate, defaultTime[0])
      const maxDate = modifyWithTimeString(val.maxDate, defaultTime[1])
      const activeInputIndex = this.activeInputIndex

      this.handleDateMouseEnter({
        newDate: activeInputIndex === 0 ? minDate : maxDate,
        isDateRangePick: !this.isValidValue([minDate, maxDate]),
        val
      })


      // this.isPanelSelectd = true // 用户是否在操作面板

      // 单边时，不走原有的逻辑，防止被阻止
      if (!this.singleValue && this.maxDate === maxDate && this.minDate === minDate) {
        return
      }
      this.onPick && this.onPick(val)
      this.maxDate = maxDate
      this.minDate = minDate

      // workaround for https://github.com/ElemeFE/element/issues/7539, should remove this block when we don't have to care about Chromium 55 - 57
      setTimeout(() => {
        this.maxDate = maxDate
        this.minDate = minDate
        if (maxDate && minDate) {
          // 区间状态纠正
          this.rangeState.selecting = false
        }
      }, 10)
      // 单边时，不走原有的逻辑，此时需要符合单个的逻辑可通过，且处理异常场景
      if (this.singleValue) {
        let value = [this.minDate, this.maxDate]

        let leng = value.filter(Boolean).length
        // 如果是点击的右侧面板，且不存在结束，maxDate不存在，但是minDate存在（此处是date-table的区间交互刻意为之）
        if (activeInputIndex === 1 && leng === 1 && !this.maxDate && this.minDate) {
          // 单边的时候，需要清掉前面的
          value = [null, this.minDate]
        }
        // TODO 下面的先注释，因为需求变更为，只选单边的时候，需要清掉后面的值。如果两个都选就两个
        // // 如果是点击的右侧面板，且不存在结束，maxDate不存在，但是minDate存在（此处是date-table的区间交互刻意为之）
        // if (activeInputIndex === 1 && leng === 1 && !this.maxDate && this.minDate) {
        //   // 则填充上一次v-model绑定的值,如果存在
        //   value = [this.value[0] || null, this.minDate]
        // } else {
        //   // 反之。优先使用 preMaxDate的值。
        //   value = [this.minDate, preMaxDate || this.maxDate]
        // }
        this.$emit('single-value-pick', { value, activeInputIndex }, leng !== 2)
        // 区间状态纠正
        this.rangeState.selecting = leng !== 2
        if (leng === 2) {
          // 如果完整，则为false
          this.rangeState.selecting = false
        }
        return
      }
      if (!close || this.showTime) return
      this.handleConfirm()
    },

    handleShortcutClick(shortcut) {
      // const disabled = typeof shortcut.disabled === 'function' ? shortcut.disabled() : shortcut.disabled
      // if (disabled) {
      //   return
      // }
      if (shortcut.onClick) {
        shortcut.onClick(this)
      } else if (typeof shortcut.value === 'function') {
        this.shortcutEmit(shortcut.value())
      } else if (shortcut.id === 'monthSelect') {
        this.changeShortcutMonth(true)
      }
    },

    changeShortcutMonth (val) {
      this.showMonthSelect = val
    },

    handleShortcutMonthClick (month) {
      const { value } = month
      this.changeShortcutMonth(false)
      let start = moment(this.rangeDate).month(value - 1).startOf('month').startOf('day').toDate()
      let end = moment(this.rangeDate).month(value - 1).endOf('month').endOf('day').toDate()
      this.shortcutEmit([start, end])
    },

    shortcutEmit (value) {
      const [minDate, maxDate] = value || []
      // 单边时，不走原有的逻辑。走自身的替换逻辑
      if (this.singleValue) {
        this.$emit('single-value-short-pick', {
          type: 'replace',
          value: [minDate, maxDate],
          activeInputIndex: this.activeInputIndex
        })
        return
      }
      this.$emit('pick', [minDate, maxDate], false)
    },

    handleMinTimePick(value, visible, first) {
      this.minDate = this.minDate || new Date()
      if (value) {
        this.minDate = modifyTime(this.minDate, value.getHours(), value.getMinutes(), value.getSeconds())
      }

      if (!first) {
        this.minTimePickerVisible = visible
      }
      // eslint-disable-next-line
      if (!this.maxDate || (this.maxDate && this.maxDate.getTime() < this.minDate.getTime())) {
        this.maxDate = new Date(this.minDate)
      }
    },

    handleMinTimeClose() {
      this.minTimePickerVisible = false
    },

    handleMaxTimePick(value, visible, first) {
      if (this.maxDate && value) {
        this.maxDate = modifyTime(this.maxDate, value.getHours(), value.getMinutes(), value.getSeconds())
      }

      if (!first) {
        this.maxTimePickerVisible = visible
      }

      if (this.maxDate && this.minDate && this.minDate.getTime() > this.maxDate.getTime()) {
        this.minDate = new Date(this.maxDate)
      }
    },

    handleMaxTimeClose() {
      this.maxTimePickerVisible = false
    },

    leftPrevYear() {
      // this.leftDate = prevYear(this.leftDate)
      // this.rightDate = nextMonth(this.leftDate)
      this.rangeDate = prevYear(this.rangeDate)
    },

    leftPrevMonth() {
      // if (!this.singleValue && !this.linkPanels) {
      //   this.leftDate = prevMonth(this.leftDate)
      //   return
      // }
      // if (this.activeInputIndex === 0 || (this.isPanelSelectd && this.activeInputIndex === 1)) {
      //   this.leftDate = prevMonth(this.leftDate)
      // } else {
      //   this.rightDate = prevMonth(this.rightDate)
      // }
      this.rangeDate = prevMonth(this.rangeDate)
    },

    rightNextYear() {
      // this.leftDate = nextYear(this.leftDate)
      // this.rightDate = nextMonth(this.leftDate)
      this.rangeDate = nextYear(this.rangeDate)
    },

    rightNextMonth() {
      // if (!this.singleValue && !this.linkPanels) {
      //   this.leftDate = nextMonth(this.leftDate)
      //   return
      // }

      // if (this.activeInputIndex === 0 || (this.isPanelSelectd && this.activeInputIndex === 1)) {
      //   this.leftDate = nextMonth(this.leftDate)
      // } else {
      //   this.rightDate = nextMonth(this.rightDate)
      // }
      this.rangeDate = nextMonth(this.rangeDate)
    },

    // leftNextYear() {
    //   this.leftDate = nextYear(this.leftDate)
    // },

    // leftNextMonth() {
    //   this.leftDate = nextMonth(this.leftDate)
    // },

    // rightPrevYear() {
    //   this.rightDate = prevYear(this.rightDate)
    // },

    // rightPrevMonth() {
    //   this.rightDate = prevMonth(this.rightDate)
    // },

    handleConfirm(visible = false) {
      let val = [this.minDate, this.maxDate]
      if (this.isWeekRange) {
        val = correctDatesOrder(val)
      }
      if (this.isValidValue(val)) {
        this.$emit('pick', val, visible)
      }
    },

    isValidValue(value, msg = '选择的时间不可用') {
      const isRange = Array.isArray(value) && value
      const isStart = isRange && value[0] && isDate(value[0])
      const isEnd = isRange && value[1] && isDate(value[1])
      const valid =
        isStart &&
        isEnd &&
        value[0].getTime() <= value[1].getTime()
      let disabledDate = true
      if (typeof this.disabledDate === 'function') {
        disabledDate = !(isStart && this.disabledDate(value[0])) && !(isEnd && this.disabledDate(value[1]))
        if (!disabledDate) {
          this.$message.warning(msg)
        }
      }
      return valid && disabledDate
    },

    resetView() {
      // NOTE: this is a hack to reset {min, max}Date on picker open.
      // TODO: correct way of doing so is to refactor {min, max}Date to be dependent on value and internal selection state
      //       an alternative would be resetView whenever picker becomes visible, should also investigate date-panel's resetView
      if (this.singleValue || this.linkPanels) {
        // 调整单边逻辑
        setTimeout(() => {
          if (this.value && this.value.filter(Boolean).length === 1) {
            this.minDate = null
            this.maxDate = null
            const minDate = isDate(this.value[0]) ? new Date(this.value[0]) : null
            const maxDate = isDate(this.value[1]) ? new Date(this.value[1]) : null
            minDate && this.$refs.leftDateTable.seStartEndCellClasses(minDate, 'min')
            maxDate && this.$refs.leftDateTable.seStartEndCellClasses(maxDate, 'max')
          }
        })
      } else {
        this.minDate = this.value && isDate(this.value[0]) ? new Date(this.value[0]) : null
        this.maxDate = this.value && isDate(this.value[0]) ? new Date(this.value[1]) : null
      }
      // this.minDate = this.value && isDate(this.value[0]) ? new Date(this.value[0]) : null
      // 单边时，不走原有的逻辑，防止maxDate被 开始时间限制
      // if (this.singleValue) {
      //   this.maxDate = this.value && isDate(this.value[1]) ? new Date(this.value[1]) : null
      //   return
      // }
      // this.maxDate = this.value && isDate(this.value[0]) ? new Date(this.value[1]) : null
    },
    hiddDatePopper() {
      if (this.$refs.leftDateTable) {
        this.$refs.leftDateTable.hiddDatePopper()
      }
      if (this.$refs.rightDateTable) {
        this.$refs.rightDateTable.hiddDatePopper()
      }
    }
  },

  components: { TimePicker, DateTable, ShortcutsWrap }
}
</script>



// WEBPACK FOOTER //
// src/public/components/kye-date-picker3/src/panel/date-range.vue